import "./ProcessGuardian.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Footer from "@/reusable_sections/Footer";
export default function ProcessGuardianPage() {
  return <div>
      <Header />
      <Hero />
      <Footer />
    </div>;
}